import { Badge } from "@/components/ui/badge";
import { Flame, ThermometerSun, Snowflake } from "lucide-react";

export const intentConfig = {
  hot: { label: "HOT", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30", Icon: Flame },
  warm: { label: "WARM", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", Icon: ThermometerSun },
  cold: { label: "COLD", cls: "bg-slate-500/15 text-slate-400 border-slate-500/30", Icon: Snowflake },
};

export const STATES = [
  { code: "CA", name: "California" },
  { code: "AZ", name: "Arizona" },
  { code: "NV", name: "Nevada" },
];

export const TIERS = {
  small: { label: "Small · <20k", price: 25, cls: "bg-sky-500/10 text-sky-400 border-sky-500/30" },
  medium: { label: "Medium · 20k–75k", price: 50, cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  large: { label: "Large · 75k+", price: 100, cls: "bg-rose-500/10 text-rose-400 border-rose-500/30" },
};

export const currency = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const ScoreBadge = ({ intent, score, leadId }) => {
  const cfg = intentConfig[intent] || intentConfig.cold;
  const { Icon } = cfg;
  return (
    <Badge
      data-testid={leadId ? `lead-score-badge-${leadId}` : "lead-score-badge"}
      className={`gap-1 font-mono text-[11px] font-semibold px-2.5 py-1 rounded-full border ${cfg.cls}`}
    >
      <Icon className="h-3 w-3" /> {cfg.label} · {score}
    </Badge>
  );
};
